





















































































































import {
  apiSearchMartSearchSearchCommodity,
  apiSearchMartSearchSearchKeyword,
} from '@/api'
import { currentChannelId } from '@/channel'
import { defineClassComponent, useLoaded } from '@/hooks'
import { defineTvListeners } from '../utils'
import { makeUniGoods, Track, UniGoods } from '@/utils'
import { navigateTo } from '@/router'
import { onMounted, ref, watch } from '@vue/composition-api'
import { range } from 'vtils'
import { useWaterfall, XWaterfallLoad } from '@/components'

export default defineClassComponent(
  ({ ctx }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          // 埋点页面名称
          page: 'TV-搜索',
        }))

        useLoaded(this.loading, () => this.goToKeyboardWords(0))

        watch(
          () => this.keyword.value,
          () => {
            this.refKeyword.value = ''
            this.loadRefKeywords()
            this.waterfall.reload()
          },
        )

        watch(
          () => this.refKeyword.value,
          () => {
            if (this.refKeyword.value) {
              this.waterfall.reload()
            }
          },
        )

        onMounted(() => {
          this.loading.value = false
        })
      }

      // 加载状态
      loading = ref(true)

      // 字母列表
      words = [
        // A-Z
        ...range(65, 65 + 26).map(i => String.fromCharCode(i)),
        // 0-9
        ...range(48, 48 + 10).map(i => String.fromCharCode(i)),
      ]

      waterfall = useWaterfall('waterfall')

      // 关键词
      keyword = ref('')

      // 联想关键词
      refKeyword = ref('')

      // 联想关键词列表
      refKeywords = ref<string[]>([])

      // 加载联想关键词
      loadRefKeywords = async () => {
        this.refKeywords.value = await apiSearchMartSearchSearchKeyword({
          keyword: this.keyword.value,
          refUserGroupId: currentChannelId,
          distributeChannel: [0],
        }).then(res => res.slice(0, 10).map(res => res.title!))
      }

      // 加载搜索数据
      loadData: XWaterfallLoad = ({ pageNumber }) => {
        return !this.keyword.value
          ? []
          : apiSearchMartSearchSearchCommodity({
              pageIndex: pageNumber,
              pageSize: 10,
              // 筛选店铺时不处理运营渠道
              refUserGroupId: currentChannelId,
              sceneId: '55f9be7e73c04949bfa7a0c850d33924',
              searchWord: this.refKeyword.value || this.keyword.value,
              sortType: '02',
            }).then(res => makeUniGoods(res.list!))
      }

      // 跳到键盘操作
      goToKeyboardActions = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.keyboardActions, index)
      }

      // 跳到键盘字母
      goToKeyboardWords = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.keyboardWords, index)
      }

      // 跳到猜你想搜
      goToGuess = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.guess, index)
      }

      // 跳到历史搜索
      goToHistory = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.history, index)
      }

      // 跳到清空历史搜索
      goToClearHistory = () => {
        ctx.$tv.goTo(ctx.$refs.clearHistory)
      }

      // 跳到商品列表
      goToList = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.list, index)
      }

      // 键盘操作监听器
      keyboardActionsListeners = defineTvListeners(({ type, el }) => {
        switch (type) {
          case 'click':
            const action: '清空' | '退格' = el.textContent!.trim() as any
            if (action === '清空') {
              this.keyword.value = ''
            } else if (action === '退格') {
              this.keyword.value = this.keyword.value.slice(
                0,
                this.keyword.value.length - 1,
              )
            }
            break
          default:
            break
        }
      })

      // 键盘字母监听器
      keyboardWordsListeners = defineTvListeners(({ type, el }) => {
        switch (type) {
          case 'click':
            const word: string = el.textContent!.trim() as any
            this.keyword.value += word
            break
          default:
            break
        }
      })

      // 猜你想搜监听器
      guessListeners = defineTvListeners(({ type, el }) => {
        switch (type) {
          case 'focus':
            const refKeyword = el.textContent!.trim()
            this.refKeyword.value = refKeyword
            break
          case 'right':
            this.goToList(0)
            break
          default:
            break
        }
      })

      // 历史搜索监听器
      historyListeners = defineTvListeners(({ type }) => {
        switch (type) {
          default:
            break
        }
      })

      // 清空历史搜索监听器
      clearHistoryListeners = defineTvListeners(({ type }) => {
        switch (type) {
          default:
            break
        }
      })

      // 商品列表监听器
      listListeners = defineTvListeners<UniGoods>(({ type, item }) => {
        switch (type) {
          case 'focus':
            ctx.$tv.setScrollEl(ctx.$refs.result)
            break
          case 'blur':
            ctx.$tv.resetScrollEl()
            break
          case 'click':
            navigateTo('TvGoodsIndex', {
              id: item.id,
            })
            break
          default:
            break
        }
      })
    },
)
